import { createSelector } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import { userDataSel } from '@modules/profile/duck/selectors';

/**
 * Returns the current logged in user date of birth as a string `yyyy-mm-dd`
 */
export const userDateOfBirthSel = createSelector(
  userDataSel,
  userData => userData.dateOfBirth,
);

/**
 * Returns the current logged in user age as a `number`
 * floored to the closest integer.
 */
export const currentUserAgeSel = createSelector(
  userDateOfBirthSel,
  dateOfBirth =>
    Math.floor(Math.abs(DateTime.fromISO(dateOfBirth).diffNow('years').years)),
);
